<template>
	<div :class="['spin', { 'survival-bonus-reached': bonus }]">
		<div class="spin-content-wrapper">
			<GameHints v-if="!bonus" />
			<SpinButton v-if="!bonus" :class="{'inactive': inactive}" :action="spin" />
			<SurvivalBonus v-if="bonus" v-bind="activeRound" />
		</div>
		<Wheel
			ref="spinningWheel"
			:sections="bummers"
			@spin="disableSpinButton"
			@spin-complete="activateBummer"
		/>
		<InfoPanel />
	</div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { randomBetween } from '@/lib/random';
import GameHints from '@/components/game/spin/GameHints';
import InfoPanel from '@/components/views/game/InfoPanel';
import SpinButton from '@/components/game/spin/wheel/SpinButton';
import SurvivalBonus from '@/components/game/spin/bummers/SurvivalBonus';
import Wheel from '@/components/game/spin/wheel/Wheel';

export default {
	name: 'SpinView',
	components: {
		GameHints,
		InfoPanel,
		SpinButton,
		SurvivalBonus,
		Wheel,
	},
	data() {
		return {
			inactive: false,
			triviaSpin: 0,
		};
	},
	computed: {
		...mapState({
			activeRound: (state) => state.game.rounds.active,
			bonus: (state) => state.game.rounds.active.activeBonus,
		}),
		...mapGetters({
			bummers: "game/bummers/wheel",
		}),
		forceTrivia() {
			return this.triviaSpin === this.$store.state.game.rounds.active.spinsRemaining;
		},
	},
	methods: {
		async activateBummer(bummer) {
			await this.$store.dispatch("game/rounds/active/removeSpins", { count: 1 });
			this.$store.dispatch(`game/bummers/activate`, bummer);
			this.inactive = false;
		},
		advance() {
			this.$router.push('/game/spin');
		},
		spin() {
			const id = this.forceTrivia ? this.bummers.find((bummer) => bummer.model === "trivia").id : false;
			this.$refs.spinningWheel.spin(id);
			this.$store.dispatch("sound/fx/play", { id: "button_generic" });
			this.$store.dispatch("sound/fx/play", { id: "wheel_spin" });
		},
		disableSpinButton() {
			this.inactive = true;
		},
	},
	mounted() {
		this.$store.dispatch("game/rounds/active/deactivateBonus");
		this.triviaSpin = randomBetween(1, this.$store.state.game.rounds.active.base_spin_count);
	},
};
</script>

<style lang="scss" scoped>
	.spin {
		@include swirl-background;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		height: 100%;
		overflow: hidden;
		padding: 0;

		@include desktop {
			flex-direction: row-reverse;
			justify-content: space-between;
		}

		@include desktop-sm { padding-top: $header-height-desktop; }
	}

	.spin-content-wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		height: 100%;
		margin-top: 50px;
		transition: all $ui-transition-duration-long;

		@include desktop {
			justify-content: flex-start;
			margin: 0 10vw 0 0;
		}

		.survival-bonus-reached & {
			margin-top: 100px;

			@include desktop { margin-top: 0; }
		}
	}

	.inactive { pointer-events: none; }

	.game-hints {
		@include desktop {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 60%;
			margin: 0;
		}

		@include desktop-sm { height: 70%; }
	}

	.survival-bonus {
		@include desktop { animation: grow $ui-transition-duration-extra-long; }
	}

	.wheel {
		margin-bottom: -100px;
		transition: all $ui-transition-duration-long;

		@include tablet { margin-bottom: -200px; }
		@include desktop { margin: 0 0 0 calc(10vw + #{$info-panel-height-mobile}); }

		.survival-bonus-reached & {
			transform: translateY(50px);
			height: 50%;

			@include desktop {
				transform: none;
				height: unset;
			}
		}
	}

	.info-panel {
		position: fixed;
		bottom: 0;

		@include desktop {
			position: absolute;
			left: 0;
			bottom: 0;
		}
	}
</style>
